import React, {useState, useEffect, useRef} from 'react';
import monerisService from '../../../services/moneris-service';
import parkingService from '../../../services/parking-service';
import Spinner from '../../../Common/Spinner';
import SnackAlert from '../../../Common/Alerts';
import { Paper } from '@mui/material';
import permitServices from '../../../services/permit-service';

var monerisDiv = 'monerisCheckout_'+Math.floor(Math.random() * 100) + 1;

function Moneris(props) {
  const MonerisRef = useRef();
  const [spinner, setSpinner] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(()=>{
    console.log('asda')
    handleMoneris();
  },[MonerisRef])

  const handleMoneris = async ()=>{
    setSpinner(true);
    let amount = (props.totalAmount/100).toFixed(2)
    const res = await monerisService.generateToken({amount: amount.toString(), org_id: props.org._id});
    if(res.data.success == 'false'){
      setAlertMessage(res.data.error.message);
      setSeverity('error');
      setShowAlert(true);
      props.back();
      return;
    }
    const script = document.createElement("script");    
    script.async = true;
    if(props.org.payment_envoirnment === 'test'){
      script.src = "https://gatewayt.moneris.com/chkt/js/chkt_v1.00.js";    // Testing
    }else{
      script.src = "https://gateway.moneris.com/chkt/js/chkt_v1.00.js";  // Production
    }
    document.body.appendChild(script);
    
    script.onload = ()=> {
        MonerisRef.current = new window.monerisCheckout();
        if(props.org.payment_envoirnment === 'test'){
          MonerisRef.current.setMode("qa");     //Testing
        }else{
          MonerisRef.current.setMode("prod");   //Production
        }
        MonerisRef.current.setCheckoutDiv(monerisDiv);
        MonerisRef.current.startCheckout(res.data.ticket);
        setSpinner(false);
        MonerisRef.current.setCallback("cancel_transaction", cancelTransaction);
        MonerisRef.current.setCallback("error_event", errorEvent);
        MonerisRef.current.setCallback("payment_receipt", myPaymentReceipt);
        MonerisRef.current.setCallback("payment_complete", myPaymentComplete);
    };
  }

  const errorEvent = (e)=>{
    console.log(e);
  }

  const myPaymentReceipt = async (e)=>{
    console.log('myPaymentReceipt')
    e = JSON.parse(e);
    console.log(e)
    const res = await monerisReceipt(e.ticket);
    console.log(res.data)
    if(res.data.receipt?.result == "a"){
      purchaseParking(e.ticket, res.data.receipt?.cc?.tokenize?.datakey);
    }
    setSpinner(false)
  }

  const myPaymentComplete = async (e)=>{
    console.log('myPaymentComplete')
    e = JSON.parse(e);
    setSpinner(true)
    const res = await monerisReceipt(e.ticket);
    setSpinner(false)
    console.log(res.data.receipt?.result)
    if(res.data.receipt?.result == "a"){
      sessionStorage.removeItem("showParking")
      window.location.reload()
    }else{
      // MonerisRef.current.closeCheckout(e.ticket);
      window.location.reload()
      // props.back();
    }
  }

  const cancelTransaction = (e)=>{
    MonerisRef.current.closeCheckout(e.ticket);
    props.back();
  }

  const monerisReceipt = async (ticket) =>{
    const res = await monerisService.monerisReceipt({ticket: ticket, org_id: props.org._id});
    return res;
  }

  const purchaseParking= async (ticket, token)=>{
    let user = JSON.parse(sessionStorage.getItem("userLogged"));
    let body = {
        ticket: ticket,
        token: token,
        payment_gateway: 'moneris',
        amount : props.totalAmount,
        plate: props.inputField.plate,
        user: user.result._id,
        zone: props.selectedZone,
        city: props.selectedZone.city_id,
        from: props.permitVal.from,
        to: props.permitVal.to,
        coord: '',
        service_fee: 0,
        org: props.org._id,
        permit: props.permitVal._id,
        next_renew_at: props.permitVal.next_renew_at,
        allow_auto_renew: props.inputField.allow_auto_renew,
        source: "webPermit"
    }
    const res = await permitServices.buyPermit(body);
    if(!res.data.message){
      props.showReciept();
      props.setParking(res.data)
    }else{
      setAlertMessage(res.data.message);
      setSeverity('error');
      setShowAlert(true);
    }
  }

  return (
    <>
      <div style={{width: '50%'}}>
        <div id={monerisDiv}></div>
      </div>
      <Spinner
        spinner = {spinner}  
      />
      <SnackAlert
        alertMessage = {alertMessage}
        showAlert = {showAlert}
        severity = {severity}
        
        closeAlert = {()=>setShowAlert(!showAlert)}
      />
    </>
  );
}

export default Moneris;